<template>
  <g class="sound">
    <g
      v-for="(sound, index) in visualizationSounds"
      :key="index"
      :transform="`translate(${sound.positionX} -${sound.positionY})`"
    >
      <use
        x="-2"
        y="-2"
        width="4"
        height="4"
        :xlink:href="`#sound-volum${level(sound.sound)}`"
      />
    </g>
  </g>
</template>

<script>
export default {
  computed: {
    spots: ({ $store }) => $store.getters['area/spotAll'],
    visualizationSounds: (vm) => vm.spots.filter((spot) => vm.isNotRestroom(spot)).map((spot) => vm.buildSoundBy(spot)),
    level: () => (value) => (value >= 2 && value <= 5) ? value : 1,
  },
  methods: {
    isNotRestroom(spot) {
      return spot.spotState && spot.type.indexOf('Restroom') < 0;
    },
    buildSoundBy(spot) {
      return {
        positionX: spot.positionX,
        positionY: spot.positionY,
        sound: spot.spotState.noise || 1,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// sound.vue?78cbb9ea